// @flow
export const filterId: 'class' = 'class';
